import { useTranslation } from "react-i18next";
import styles from "./StatisticCards.module.scss";
import CountUp from "react-countup";
import { useEffect, useState } from "react";
import DashboardService from "../../../api/services/dashboard.service";
import { DashboardStatistics } from "../../../api/types/dashboard.types";

const StatisticCards = () => {
  const { t } = useTranslation("translation");
  const [statistics, setStatistics] = useState<DashboardStatistics | null>(
    null,
  );

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await DashboardService.getStatisticsData();
        setStatistics(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    getData();
  }, []);
  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1) + "K";
    }
    return num.toString();
  };

  const formatCurrency = (num: number, currency: string = "AZN") => {
    // Format with 2 decimal places and add currency
    return num.toFixed(2) + " " + currency;
  };

  return (
    <section id={styles.info_counter_section}>
      <div className={styles.info_counters_container}>
        <div className={styles.info_counter}>
          <div className={styles.info_details}>
            <p className={styles.title}>{t("statistics.total_sales")}</p>
            <h1 className={styles.count}>
              <CountUp
                duration={2.75}
                end={statistics?.total_sales || 0}
                formattingFn={formatNumber}
              />
            </h1>
          </div>
        </div>
        <div className={styles.info_counter}>
          <div className={styles.info_details}>
            <p className={styles.title}>{t("statistics.store_percentage")}</p>
            <h1 className={styles.count}>
              <CountUp
                duration={2.75}
                end={statistics?.percent || 0}
                formattingFn={(value) => formatNumber(value) + " %"}
              />
            </h1>
          </div>
        </div>
        <div className={styles.info_counter}>
          <div className={styles.info_details}>
            <p className={styles.title}>{t("statistics.net_profit")}</p>
            <h1 className={styles.count}>
              <CountUp
                duration={2.75}
                end={statistics?.net_profit || 0}
                decimals={2}
                formattingFn={(value) =>
                  formatCurrency(value, statistics?.currency || "AZN")
                }
              />
            </h1>
          </div>
        </div>
        <div className={styles.info_counter}>
          <div className={styles.info_details}>
            <p className={styles.title}>{t("statistics.total_products")}</p>
            <h1 className={styles.count}>
              <CountUp
                duration={2.75}
                end={statistics?.all_products || 0}
                formattingFn={formatNumber}
              />
            </h1>
          </div>
        </div>
        <div className={styles.info_counter}>
          <div className={styles.info_details}>
            <p className={styles.title}>{t("statistics.inventory_cost")}</p>
            <h1 className={styles.count}>
              <CountUp
                duration={2.75}
                end={statistics?.inventory_cost || 0}
                decimals={2}
                formattingFn={(value) =>
                  formatCurrency(value, statistics?.currency || "AZN")
                }
              />
            </h1>
          </div>
        </div>
        <div className={styles.info_counter}>
          <div className={styles.info_details}>
            <p className={styles.title}>{t("statistics.gross_profit")}</p>
            <h1 className={styles.count}>
              <CountUp
                duration={2.75}
                end={statistics?.gross_profit || 0}
                decimals={2}
                formattingFn={(value) =>
                  formatCurrency(value, statistics?.currency || "AZN")
                }
              />
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatisticCards;
